(function() {
	// globals
	PM.Utils = {};

	// utility functions

	/**
	 * Parse a locale-formatted number string back to a float.
	 * i18next formats numbers via i18next.format(value, 'number'); this helper
	 * reverses that for input fields where the user types locale-formatted values.
	 * @param {string} str - The locale-formatted string
	 * @returns {number} The parsed number, or NaN
	 */
	PM.Utils.parseNumber = function(str) {
		if (typeof str !== 'string' || str.trim() === '') return NaN;
		var locale = i18next.language || 'en';
		// Detect decimal separator from Intl (e.g. '.' for en, ',' for de/it)
		var decimalSep = new Intl.NumberFormat(locale).format(1.5).charAt(1);
		var normalized = str.trim();
		if (decimalSep === ',') {
			normalized = normalized.replace(/\./g, '').replace(',', '.');
		} else {
			normalized = normalized.replace(/,/g, '');
		}
		return parseFloat(normalized);
	};

	// app functions

	// events

	// app startup

	// set language
	i18next
	.use(i18nextBrowserLanguageDetector)
	.use(i18nextHttpBackend)
	.init({
		detection: {
			order: ['querystring', 'cookie', 'navigator'],
			lookupQuerystring: 'lang',
			lookupCookie: 'current-language',
			caches: ['cookie'],
			cookieMinutes: 5256000,
			cookieDomain: (function() {
				var hn = window.location.hostname;
				if (hn === 'localhost' || /^(\d{1,3}\.){3}\d{1,3}$/.test(hn)) return undefined;
				var p = hn.split('.');
				return p.length >= 2 ? '.' + p.slice(-2).join('.') : undefined;
			})(),
			cookieOptions: {samesite: 'lax', path: '/'}
		},
		supportedLngs: ['en', 'de', 'it'],
		load: 'languageOnly',
		fallbackLng: 'en',
		backend: {
			loadPath: '/i18n/{{lng}}.json'
		}
	})
	.then(function() {
		// language initialized
		// if there is a lang query string parameter, remove it and reload: we save the language in a cookie so the url stays nice
		var urlQueryString = new URLSearchParams(window.location.search);
		if (urlQueryString.has('lang')) {
			urlQueryString.delete('lang');
			var newUrl = [location.protocol, '//', location.host, location.pathname].join('') +
				(urlQueryString.toString() !== '' ? '?' + urlQueryString.toString() : '') +
				window.location.hash;
			window.location = newUrl;
			return;
		}

		// render main shell
		PM.Shell.renderShell()
		.then(function() {
			// 404 catch-all — registered last, before dispatch; skip API paths
			page('*', function(ctx) {
				if (ctx.pathname.indexOf('/api/') === 0 || ctx.pathname.indexOf('/docs/') === 0 || ctx.pathname.indexOf('/mcp') === 0) {
					window.location.href = ctx.pathname + (ctx.querystring ? '?' + ctx.querystring : '');
					return;
				}
				PM.Shell.renderNotFound();
			});

			//setup routing
			page({
				hashbang: false
			});
		});
	});

})();
